module.exports = __webpack_public_path__ + "img/rank-1.3d68ae81.png";